export default __webpack_public_path__ + "50b0e0e63516044a8dc84dc6f94897ea.gif";